module.exports = __webpack_public_path__ + "img/pw.78aaead2.svg";